interface GetDeviceLabelByIdResponse {
  label: string | undefined;
  error: string | undefined;
}

export const getDeviceLabelById = async (
  deviceId: string,
): Promise<GetDeviceLabelByIdResponse | undefined> => {
  if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
    return { label: undefined, error: "enumerateDevices() not supported." };
  }

  try {
    const devices = await navigator.mediaDevices.enumerateDevices();
    const device = devices.find((device) => device.deviceId === deviceId);
    return { label: device?.label, error: undefined };
  } catch (err) {
    return { label: undefined, error: `${err.name}: ${err.message}` };
  }
};
